import React, { useState } from 'react'
import { TextArea } from 'sutra/components'

import {
  PaneContainer,
  PaneDescription,
} from 'features/charts-v2/components/filter-popover-pane.styles'
import { FilterPopoverPaneFooter } from 'features/charts-v2/components/FilterPopoverPaneFooter/FilterPopoverPaneFooter'
import { parseKeywordInput } from 'features/charts-v2/utils/parse-keyword-input'

export const TOO_MANY_VALUES_MESSAGE =
  'Too many values to display. Enter exact values below, separated by commas or new lines.'

const FREE_INPUT_PLACEHOLDER = 'Enter values separated by commas or new lines'

interface FilterPopoverFreeInputPaneProps {
  committedValues: readonly string[]
  onApply: (values: string[]) => void
  onClear: () => void
}

// Editing pane for a select field whose distinct values the backend withheld
// (the filter-options cache caps each select field at
// `filter_options_count_limit` and ships `values: []` above it — an ID-like
// field such as "Conversation ID" always lands here). There is nothing to
// tick, so the user types the exact values instead; Apply commits them as a
// plain equality selection, exactly as if they had been checked in a list.
// Mirrors the feed panel's FreeInput behaviour for the same case.
export const FilterPopoverFreeInputPane: React.FC<
  FilterPopoverFreeInputPaneProps
> = ({ committedValues, onApply, onClear }) => {
  const [draft, setDraft] = useState(committedValues.join('\n'))
  const draftValues = parseKeywordInput(draft)

  return (
    <PaneContainer>
      <PaneDescription>{TOO_MANY_VALUES_MESSAGE}</PaneDescription>
      <TextArea
        aria-label="Filter values"
        rows={6}
        value={draft}
        placeholder={FREE_INPUT_PLACEHOLDER}
        onChange={(e) => setDraft(e.target.value)}
      />
      <FilterPopoverPaneFooter
        onApply={() => onApply(draftValues)}
        onClear={() => {
          setDraft('')
          onClear()
        }}
        applyDisabled={draftValues.length === 0}
        clearDisabled={draft.length === 0 && committedValues.length === 0}
      />
    </PaneContainer>
  )
}
